import { css } from 'aphrodite';
import { OutboundTextMessageBubble } from '../MessageBubble/OutboundTextMessageBubble';
import { brandPrimary } from '../../../styles/colors';
import { bs } from '../../../styles/styles';

export function TextCampaignFooter() {
	return (
		<div className={css(bs.mt4)}>
			<OutboundTextMessageBubble backgroundColor={brandPrimary}>
				If you&apos;d prefer not to hear from me by text message, please reply back with &quot;Stop&quot;.
			</OutboundTextMessageBubble>
			<div className={css(bs.textRight, bs.textXs, bs.textHeader, bs.italic, bs.mt1)}>*Required by CAN-SPAM</div>
		</div>
	);
}
